import { SkyDialog, SkyText } from "@skypointcloud/skypoint-ui";

/**
 * Asks before a run is cancelled (S1): from the Runs row menu and from the run page. Cancelling
 * stops the running jobs and cannot be undone, and a load cut short can leave data half loaded,
 * so the click that does it is never the first one. "Keep running" is the safe, default way out.
 */
export interface CancelRunDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function CancelRunDialog({ open, onOpenChange, onConfirm }: CancelRunDialogProps) {
  return (
    <SkyDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Cancel this run?"
      size="small"
      testId="cancel-run-dialog"
      primaryAction={{
        label: "Cancel run",
        destructive: true,
        onClick: () => {
          onOpenChange(false);
          onConfirm();
        },
      }}
      secondaryAction={{ label: "Keep running", onClick: () => onOpenChange(false) }}
    >
      <SkyText size={300} block>
        Data already loaded in this run may be incomplete.
      </SkyText>
    </SkyDialog>
  );
}
